/**
 * OrderDashboardContainer
 *
 *
 */

import React, { useState, useEffect } from 'react';
import OrderDashboardPresenter from './OrderDashboardPresenter';
import MessageAlert from 'utils';
import { CartApi, StatisticsApi } from 'api';
import dayjs from 'dayjs';
import moment from 'moment';

const DAY = -15;
const MOMENT_FORMAT = 'YYYY-MM-DD';
const startDate = moment().startOf('month').format(MOMENT_FORMAT);
const endDate = moment().format(MOMENT_FORMAT);

/**----------------------------------------
 * [Component] 총관리자: 장바구니 분석 - 컨테이너
 * ----------------------------------------
 */
const OrderDashboardContainer = ({ defaultShopId, permission }) => {
  /* ===== INIT ===== */
  /* ===== STATE ===== */
  const [currentShop, _setCurrentShop] = useState(defaultShopId ?? null);
  const [statisticsType, setStatisticsType] = useState('month');
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState({
    product: null,
    category: null,
    shop: null,
    rawData: null,
  });
  const [orderList, setOrderList] = useState({
    parcelSale: [],
    refundSale: [],
  });
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**--------------------
   * 일별 주문내역 조회
   * --------------------
   */
  const getOrderList = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await StatisticsApi.getStatistics(
        `parcel_service`,
        {
          startDate,
          endDate,
          // shopId: 12,
          ...(currentShop && { shopId: currentShop }),
        }
      );
      if (status !== 200) throw { message };
      setOrderList(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /**
   * 카트목록 조회
   * --
   */
  const handleGetCartList = async () => {
    setLoading(true);
    try {
      const dd =
        statisticsType === 'today'
          ? 1
          : statisticsType === 'week'
          ? -7
          : statisticsType === 'month'
          ? -30
          : -90;
      const { status, message, data } = await StatisticsApi.getStatistics(
        'cart',
        {
          startDate: dayjs().add(dd, 'days').startOf().format('YYYY-MM-DD'),
          endDate: dayjs().endOf().format('YYYY-MM-DD'),
          ...(defaultShopId && { shopId: currentShop }),
        }
      );
      if (status !== 200) throw { message };

      // Product ID별로 분류하여 저장
      const groupedByProductId = data.reduce((acc, item) => {
        if (!acc[item.product_id]) {
          acc[item.product_id] = {
            label: item.product_name,
            price: item.product_price,
            shop_information_name: item.shop_information_name,
            data: [],
          };
        }
        acc[item.product_id].data.push(item);
        return acc;
      }, {});

      // Category ID별로 분류하여 저장
      const groupedByCategoryId = data.reduce((acc, item) => {
        if (!acc[item.category_id]) {
          acc[item.category_id] = { label: item.category_name, data: [] };
        }
        acc[item.category_id].data.push(item);
        return acc;
      }, {});

      // Shop ID별로 분류하여 저장
      const groupedByShopId = data.reduce((acc, item) => {
        if (!acc[item.shop_information_id]) {
          acc[item.shop_information_id] = {
            label: item.shop_information_name,
            data: [],
          };
        }
        acc[item.shop_information_id].data.push(item);
        return acc;
      }, {});

      setTimeout(() => {
        setChartData({
          product: groupedByProductId,
          category: groupedByCategoryId,
          shop: groupedByShopId,
          rawData: data,
        });
        setLoading(false);
      }, 850);
    } catch (e) {
      setLoading(false);
      console.log('[OrderDashboardContainer][handleGetCartList] Error: ', e);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  /*  */
  useEffect(() => {
    handleGetCartList();
  }, []);
  /*  */
  useEffect(() => {
    handleGetCartList();
    getOrderList();
  }, [currentShop]);

  /* ===== RENDER ===== */
  const props = {
    loading,
    chartData,
    permission,
    statisticsType,
    orderList,
    setStatisticsType,
    handleGetCartList,
    startDate,
    endDate,
  };
  // JSX: start
  return (
    <>
      <OrderDashboardPresenter {...props} />
    </>
  ); // JSX: end
};

OrderDashboardContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
};
export default OrderDashboardContainer;
